import { RfqMaxAmountsDto } from '../dto';
import { RfqMaxAmounts } from '../model';

export class RfqMaxAmountsFactory {
  public static createFromDto(dto: RfqMaxAmountsDto): RfqMaxAmounts {
    const rfqMaxAmounts = new RfqMaxAmounts();
    rfqMaxAmounts.maxSellAmount = dto?.maxSellAmount
      ? BigInt(dto.maxSellAmount)
      : 0n;
    rfqMaxAmounts.maxBuyAmount = dto?.maxBuyAmount
      ? BigInt(dto.maxBuyAmount)
      : 0n;
    rfqMaxAmounts.maxValueInUsd = dto?.maxValueInUsd || 0;
    return rfqMaxAmounts;
  }
}
